// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Cn-z","badgeLink":"Dn-z","category":"En-z"};